import {
    Box,
    Pagination,
    Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchProducts, getShop } from '../features/slices';
import ProductCard from '../components/ProductCard';
import LayoutContainer from '../components/LayoutWrapper';

const Shop = () => {
    const dispatch = useDispatch();
    const { products, page, totalPages, template } = useSelector((state) => state.shop);

    useEffect(() => {
        dispatch(getShop({ template, page, limit: 15 }));
    }, [dispatch, page, template]);

    const handlePageChange = (event, value) => {
        dispatch(getShop({ template, page: value, limit: 15 }));
    };

    return (
        <LayoutContainer>

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: '100%',
                    p: 0,
                    m: 0,
                }}
            >
                {products.map((product) => (
                    <Box
                        key={product.id}
                        sx={{
                            width: {
                                xs: '100%',  // 1 cột trên điện thoại
                                sm: '50%',   // 2 cột trên màn hình nhỏ
                                md: '33.33%',// 3 cột trên tablet
                                lg: '25%',   // 4 cột trên desktop vừa
                                xl: '20%',   // 5 cột trên desktop lớn
                            },
                            p: 1,
                            boxSizing: 'border-box',
                        }}
                    >
                        <ProductCard product={product} />
                    </Box>
                ))}
            </Box>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        shape="rounded"
                    />
                </Box>
            )}
        </LayoutContainer>
    );
};

export default Shop;
